import React from 'react';
import { withStyles, WithStyles } from '@material-ui/core';
import CustomSwitch from '../../../../Dispatch/RouteExecution/DriverPopUp/common/CustomSwitch';
import CustomTextField from '../../../../Dispatch/RouteExecution/DriverPopUp/common/CustomTextField';

const styles = () => ({
  toggleRow: {
    display: 'flex',
    alignItems: 'center' as const,
    gap: '8px',
    marginTop: '-8px',
  },
  emailInput: {
    maxWidth: 300,
    marginTop: 12,
    '& .MuiOutlinedInput-root': {
      height: 40,
    },
  },
});

interface AdvanceDeliveryNotificationProps extends WithStyles<typeof styles> {
  isToggleOn: boolean;
  email: string;
  onToggleChange: (value: boolean) => void;
  onEmailChange: (value: string) => void;
  error?: string;
}

const AdvanceDeliveryNotification: React.FC<AdvanceDeliveryNotificationProps> = (props) => {
  const { isToggleOn, email, onToggleChange, onEmailChange, error, classes } = props;
  const handleToggleChange = (value: boolean) => {
    onToggleChange(value);
  };

  const handleEmailChange = (value: string) => {
    onEmailChange(value);
  };

  return (
    <>
      <div className={classes.toggleRow}>
        <span>
          Send notification when driver is out for delivery
        </span>
        <CustomSwitch
          rowLabel=""
          value={Boolean(isToggleOn)}
          onChange={handleToggleChange}
        />
      </div>
      {isToggleOn && (
        <CustomTextField
          hideClearIcon
          className={classes.emailInput}
          label="Email Address"
          variant="outlined"
          value={email || ''}
          handleChange={handleEmailChange}
          error={error}
          placeholder="Enter email address"
          fullWidth
        />
      )}
    </>
  );
};

export default withStyles(styles)(AdvanceDeliveryNotification);
